import { Waypoint } from 'react-waypoint';

import { Carousel } from '@change-corgi/design-system-legacy/components/content';

import { AutoTaggedPetition } from './components/AutoTaggedPetition';
import { DecisionMakerRecommendation } from './components/DecisionMakerRecommendation';
import { EmailDecisionMaker } from './components/EmailDecisionMaker';
import { FreePromotionNotification } from './components/FreePromotion';
import { FreePromotionFulfillment } from './components/FreePromotionFulfillment';
import { NOTIFICATION_TYPES } from './constants';
import { useNotificationsCenter } from './hooks/useNotificationsCenter';

export function NotificationsCenter() {
	const { data, actions } = useNotificationsCenter();

	return (
		<Carousel
			color="primary-white"
			sx={{
				alignItems: 'center',
				// eslint-disable-next-line @typescript-eslint/naming-convention
				'& > #carousel-dots': {
					display: 'none',
				},
			}}
		>
			{data.notifications.map((notification) => {
				switch (notification.type) {
					case NOTIFICATION_TYPES.freePromotionFulfillment:
						return (
							<div className="flex h-full w-full" key="free-promotion-fulfillment">
								<FreePromotionFulfillment />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.promotion:
						return (
							<div className="flex h-full w-full" key="free-promo">
								<FreePromotionNotification />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.decisionMakerRecommendation:
						return (
							<div className="flex h-full w-full" key="dm-recommendation">
								<DecisionMakerRecommendation />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.autoTaggedPetition:
						return (
							<div className="flex h-full w-full" key="auto-tagged">
								<AutoTaggedPetition />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);

					case NOTIFICATION_TYPES.emailDecisionMaker:
						return (
							<div className="flex h-full w-full" key="starter-can-email-dm">
								<EmailDecisionMaker />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					default:
						return null;
				}
			})}
		</Carousel>
	);
}
